// src/pages/errors/Forbidden.tsx
import { Link } from "react-router-dom";

export default function Forbidden() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="text-sm font-semibold text-gray-900">403 — Forbidden</div>
        <div className="mt-2 text-sm text-gray-600">
          You don’t have permission to access this page.
        </div>

        <div className="mt-5 flex gap-2">
          <Link
            to="/account"
            className="inline-flex items-center justify-center rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700"
          >
            Go to My Account
          </Link>
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Try Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
